import styled from 'styled-components';

export const Title = styled.p`
  color: #fffefd;
  font-size: 24px;
  font-weight: 700;
`;

export const Description = styled.p`
  color: var(--color-neutral-4);
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
`;

export const RewardWrapper = styled.div`
  background: rgba(196, 245, 56, 0.1);
  padding: 16px 20px;
  border-radius: 12px;
`;

export const RewardText = styled.p`
  color: #c4f538;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const RewardAmount = styled.p`
  color: #fffefd;
  font-family: Public-Sans, sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.44px;
  margin-left: 4px;
`;

export const StartQuestText = styled.p`
  color: #10141b;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`;
